// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6d5433f0","152":"77e26e75","849":"5f90e132"}[chunkId] + ".chunk.js";
};